import React from 'react'
import { IonSpinner, IonText } from '@ionic/react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { getNotificationCenterSelector } from '../selectors'
import QaFlags from '../../qaFlags/QAFlags/QaFlags.component'
import './NotificationCenter.component.css'

interface INotificationCenterProps {
  onCloseMenu: () => void
}

const NotificationCenter: React.FC<INotificationCenterProps> = ({ onCloseMenu }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { items, isLoading } = useSelector(getNotificationCenterSelector)
  const isInPcr = (history.location?.pathname ?? '').startsWith(AppRouterConstants.TABS_ROUTE)

  return (
    <div className='notification-center ion-padding-horizontal'>
      {isInPcr && items.length > 0 && (
        <div className='notification-center-warning p-10 mb-10' role='alert'>
          <IonText className='notification-center-warning-title fw-700 m-0 mb-5'>
            {t('notifications.important')}
          </IonText>
          <IonText className='m-0'>{t('notifications.selectFlagWarning')}</IonText>
        </div>
      )}
      {isLoading && items.length === 0 ? (
        <div className='notification-center-loader ion-padding' data-testid='NotificationCenterLoader'>
          <IonSpinner data-testid='NotificationCenterSpinner' />
        </div>
      ) : (
        <QaFlags onCloseMenu={onCloseMenu} />
      )}
    </div>
  )
}

export default NotificationCenter
